import React from 'react'
import { ComfortTerm } from '@shared/components/sections/comfort-terms/model'
import CashInShape from '@shared/svg/in-shape/cash.svg'
import DocsInShape from '@shared/svg/in-shape/docs.svg'
import GrowInShape from '@shared/svg/in-shape/grow.svg'
import OfficeInShape from '@shared/svg/in-shape/office.svg'
import PercentRoundInShape from '@shared/svg/in-shape/percentRound.svg'
import TimeInShape from '@shared/svg/in-shape/time.svg'
import { type JournalPoint } from 'screens/about/sections/journal/data'

import styles from './style.module.scss'
import Link from 'next/link'
import { PagesPath } from 'data/pages-titles'

export const faqData = [
	{
		title:
			'Возможно ли получить заём под залог квартиры, если были просрочки и плохая кредитная история?',
		content:
			'Мы лояльно относимся к кредитной истории и работаем с клиентами, у которых есть просрочки, займы или другие задолженности. Получить кредит на выгодных условиях возможно даже при плохой кредитной истории и отказах от других банков.',
	},
	{
		title: 'На какой срок и сумму предоставляются кредиты?',
		content: 'Кредит предоставляется на сумму до 15 млн и срок до 20 лет.',
	},
	{
		title: 'Как узнать ставку по кредиту?',
		content: (
			<div>
				Заполните заявку на сайте, пройдите авторизацию через «Госуслуги» и примите звонок от нашего
				менеджера. Мы позвоним в течение первых пяти минут после того, как вы оставите заявку.
				Оператор задаст вам несколько вопросов, которые помогут сформировать итоговое предложение по
				кредиту.
				<br />
				<br />
				Что нужно знать: у нас нет дополнительных страховок и скрытых платежей, а также сама ставка
				по кредиту находится на уровне ведущих банков. Мы рекомендуем сравнить предложения с другими
				кредиторами, что поможет вам принять взвешенное и ответственное решение.
				<br />
				<br />
				Полезная статья:{' '}
				<Link
					href='https://percent.credit.club/kak-samomu-sravnit-predlozhenija-kreditorov/'
					target='_blank'
					rel='noopener nofollow noreferrer'
				>
					https://percent.credit.club/kak-samomu-sravnit-predlozhenija-kreditorov/
				</Link>
			</div>
		),
	},
	{
		title: 'Какие требования к заёмщику?',
		content: (
			<ul className={styles.faqPointList}>
				<li>Гражданство РФ.</li>
				<li>Любая кредитная история.</li>
				<li>Любая форма дохода.</li>
				<li>Возраст — от 21 до 65 лет.</li>
				<li>Подтверждение дохода не требуется.</li>
			</ul>
		),
	},
	{
		title: 'Какие нужны документы для рассмотрения заявки?',
		content: 'Минимальный пакет документов: паспорт и документы на объект залога.',
	},
	{
		title: 'Зачем авторизовываться через Госуслуги?',
		content: (
			<div>
				Это стандартный шаг у большинства кредиторов. Он необходим, чтобы идентифицировать клиента и
				получить по нему информацию, которая поможет в принятии решения по кредиту. Также этот шаг
				упрощает работу с клиентом: необходимые данные для заявки подтягиваются автоматически, что
				исключает долгое заполнение заявки.
				<br />
				<br />
				Благодаря авторизации через Госуслуги мы сможем сформировать предварительное одобрение за
				пару минут.
				<br />
				<br />
				Юридические подробности:
				<br />
				<br />
				<ul className={styles.faqPointList}>
					<li>
						Согласно закону от 07.08.2001 г. № 115-ФЗ от 07.08.2001, финансовые организации обязаны
						располагать идентификационными сведениями клиентов.
					</li>
					<li>
						Для вашего удобства мы запрашиваем доступ к Госуслугам, чтобы вам не пришлось предоставлять
						эти сведения в виде оригинала документа или заверенной копии, а также актуализировать
						представленные сведения личным обращением к кредитору в течение срока действия договора.
					</li>
					<li>
						Ваши данные защищены в соответствии с законом 27.07.2006 N 152-ФЗ, что гарантирует, что мы
						не сможем выполнять никаких действий от вашего имени.
					</li>
				</ul>
			</div>
		),
	},
	{
		title: 'Нужно ли платить за оформление документов или оценку недвижимости?',
		content:
			'Нет, мы не взимаем комиссии за оформление документов, оценку недвижимости и на другие услуги. Все расходы по сделке — на нас.',
	},
	{
		title: 'Можно ли взять кредит, если квартира уже находится в залоге?',
		content:
			'Да, мы рассмотрим вашу заявку. Мы умеем рефинансировать такие кредиты и находить решение для наших клиентов в любой ситуации.',
	},
	{
		title: 'Credit.Club же не является брокером или финансовым маркетплейсом?',
		content:
			'Credit.Club не является брокером или финансовым маркетплейсом. Мы выдаем деньги напрямую с наших портфельных организаций и портфельных организаций наших партнеров без лишних посредников, комиссий, страховок и подключения дополнительных услуг.',
	},
	{
		title: 'А чем еще знаменит Credit.Club?',
		content: (
			<div>
				<strong>Первое.</strong> Совместно с нашим партнёром АФГ «Процент» содействуем развитию
				финансовой грамотности в России. Работаем по заветам Банка России и помогаем людям не
				потерять деньги из-за рисков на финансовом рынке.
				<br />
				<br />
				Делимся экспертизой:
				<ul className={styles.faqDecimalList}>
					<li>
						В журнале «Процент»:{' '}
						<Link
							href='https://percent.credit.club/'
							target='_blank'
							rel='noopener nofollow noreferrer'
						>
							https://percent.credit.club/
						</Link>
					</li>
					<li>
						На ютуб-канале:{' '}
						<Link
							href='https://youtube.com/@creditclubvideo'
							target='_blank'
							rel='noopener nofollow noreferrer'
						>
							https://youtube.com/@creditclubvideo
						</Link>
					</li>
					<li>
						В телеграм-канале:{' '}
						<Link
							href='https://t.me/percent_creditclub'
							target='_blank'
							rel='noopener nofollow noreferrer'
						>
							https://t.me/percent_creditclub
						</Link>
					</li>
				</ul>
				<br />
				<strong>Второе.</strong> Строим партнерские отношения с ведущими финансовыми маркетплейсами
				«Банки.ру», «Сравни.ру» и «Банкирос».
				<br />
				<br />
				<strong>Третье.</strong> Боремся с телефонным мошенничеством:{' '}
				<Link
					href='https://percent.credit.club/protivostoim-telefonnym-moshennikam/'
					target='_blank'
					rel='noopener nofollow noreferrer'
				>
					https://percent.credit.club/protivostoim-telefonnym-moshennikam/
				</Link>
				<br />
				<br />
				<strong>Четвёртое.</strong> Реальные отзывы о Credit.Club:
				<ul className={styles.faqList}>
					<li>Страница с отзывами</li>
					<li>Отзывы на «Яндексе»</li>
				</ul>
				<br />
				<strong>Пятое.</strong> Познакомьтесь с нами:{' '}
				<Link href={PagesPath.about}>https://credit.club/about</Link>
			</div>
		),
	},
]

export const titleFeedback = (
	<>
		Команда Credit.Club работает с 2012 года.
		<br /> На полном доверии клиентов
	</>
)

export const journalPointsTabLoan: JournalPoint[] = [
	{
		content: 'Плюсы и минусы кредита под залог недвижимости',
		imageUrl: 'journal-item1-new.jpg',
		imageUrlMobile: 'journal-item1-mob-new.png',
		href: 'https://journal.credit.club/chto-takoe-kvalifitsirovannaya-elektronnaya-podpis',
		imageClassName: styles.image,
	},
	{
		content: 'Как отказаться от страховки по кредиту',
		imageUrl: 'journal-item2-new.jpg',
		imageUrlMobile: 'journal-item2-mob-new.png',
		href: 'https://journal.credit.club/kak-otkazatsya-ot-strahovki-po-kreditu',
		imageClassName: styles.image,
	},
	{
		content: 'Что такое простая электронная подпись и зачем она нужна',
		imageUrl: 'journal-item3-new.jpg',
		imageUrlMobile: 'journal-item3-mob-new.png',
		href: 'https://journal.credit.club/kak-vzyat-dengi-pod-zalog-nedvizhimosti',
		imageClassName: styles.image,
	},
]

export const youtuVideo = {
	src: '/videos/How-mortgage-lending-works.mp4',
	poster: '/images/how-loan-works.jpg',
}

export const comfortTerms: ComfortTerm[] = [
	{
		id: '1',
		title: 'Быстрое одобрение',
		icon: <TimeInShape />,
	},
	{
		id: '2',
		title: 'Любая кредитная история',
		icon: <DocsInShape />,
	},
	{
		id: '3',
		title: 'Доступные кредитные ставки',
		icon: <CashInShape />,
	},
	{
		id: '4',
		title: 'Никаких брокерских комиссий',
		icon: <PercentRoundInShape />,
	},
	{
		id: '5',
		title: 'Без посещения офиса по всей России',
		icon: <OfficeInShape />,
	},
	{
		id: '6',
		title: 'Высокая вероятность одобрения',
		icon: <GrowInShape />,
	},
]
